import { ThemeOptions } from '@mui/material';
import { CobrandIdentifier } from 'features/cobrand/types';
import { generateTheme } from 'themes/generateTheme';

export const bcbsKansasCityLightTheme: ThemeOptions = generateTheme(
  CobrandIdentifier.BCBS_KANSAS_CITY,
);
export const bcbsSouthCarolinaLightTheme: ThemeOptions = generateTheme(
  CobrandIdentifier.BCBS_SOUTH_CAROLINA,
);
export const bcbsTennesseeLightTheme: ThemeOptions = generateTheme(
  CobrandIdentifier.BCBS_TENNESSEE,
);
export const hphcLightTheme: ThemeOptions = generateTheme(CobrandIdentifier.HARVARD_PILGRIM);
export const hscsnLightTheme: ThemeOptions = generateTheme(CobrandIdentifier.HSCSN);
export const wellframeLightTheme: ThemeOptions = generateTheme(CobrandIdentifier.WELLFRAME);
export const careFirstLightTheme: ThemeOptions = generateTheme(CobrandIdentifier.CARE_FIRST);
export const careElevateLightTheme: ThemeOptions = generateTheme(CobrandIdentifier.CARE_ELEVATE);
